import i18n from "@/locale/locale.config";
import moment from "moment";
import { Messages } from "./messages.util";

export class GenericsUtils {
  isAlreadyExists(obj: any, list: any): boolean {
    var result = false;
    for (var i = 0; i < list?.length; i++) {
      if (list[i]?.name === obj?.name) {
        result = true;
        return result;
      }
    }
    return result;
  }

  fileBuild(
    data: any,
    file: any,
    appendName: { file: "file"; data: "data" },
    fileType?: string
  ): FormData {
    const strData = JSON.stringify(data);
    const formData = new FormData();
    const fileTypeString = fileType ?? "application/json";
    const jsonApp = new Blob([strData], { type: fileTypeString });

    if (file?.lastModified) {
      formData.append(appendName?.file, file);
    }
    formData.append(appendName?.data, jsonApp);
    return formData;
  }

  generateRandomId(): number {
    return Math.floor(Math.random() * 1000);
  }

  urlGo: string = "/access-file/";
  getSecureUrl(url: string): string {
    return this.urlGo?.concat(url);
  }

  getMimeType(value: string): string {
    const mimeType = value?.split("/");
    if (!mimeType) return "";
    const type = mimeType?.length > 1 ? mimeType[1] : mimeType[0];
    return type;
  }

  getDurationTime(sec: number): string {
    const hours = String(Math.floor(sec / 3600));
    const minutes = String(Math.floor((sec % 3600) / 60));
    return hours !== "0"
      ? hours.concat("h ") + minutes.concat("min")
      : minutes.concat("min");
  }

  stringToSeconds(value: string): number {
    const arr: any = value?.split(":");
    return arr.reduce((acc: any, time: any) => String(60 * acc + +time));
  }

  navigatorLanguage(): string {
    var lang: string = "";
    if (navigator.language == "en-US" || navigator.language == "en") {
      lang = "en";
    } else if (navigator.language == "pt-BR" || navigator.language == "pt") {
      lang = "pt";
    } else {
      lang = "pt";
    }
    return lang;
  }

  getImageUrl(path): string {
    return require(`/src/${path}`);
  }

  static translateI18n(key: string): string {
    return i18n.global.t(key);
  }

  csvToArray(str: any): any[] {
    let arr = str.split("\\n").map((line) => {
      return line.replaceAll('"', " ").split(",");
    });
    return arr;
  }

  csvErrorHandler(code: any): string {
    return Messages[code];
  }

  getDate(date: string): string {
    let result: any = date.split(" ");
    result = moment(result[0]).format("DD/MM/YYYY");
    return result;
  }

  onOrder<T>(
    event: string,
    index: number,
    data: T,
    action: (index, actual) => void
  ): void {
    if (event === "up") this.toUp(index, data, action);
    else this.toDown(index, data, action);
  }

  toUp<T>(index: number, data: T, action: (index, actual) => void): void {
    if (index > 0) {
      [data[index], data[index - 1]] = [data[index - 1], data[index]];
      data[index].index = index;
      data[index - 1].index = index - 1;
      action(index, index - 1);
    }
  }

  toDown<T>(index: number, data: T, action: (index, actual) => void): void {
    if (index < (data as any).length - 1) {
      [data[index], data[index + 1]] = [data[index + 1], data[index]];
      data[index].index = index;
      data[index + 1].index = index + 1;
      action(index, index + 1);
    }
  }
  
  formatTime(seconds: number): string {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const formattedHrs = String(hrs).padStart(3, "0");
    const formattedMins = String(mins).padStart(2, "0");
    const formattedSecs = String(secs).padStart(2, "0");

    return `${formattedHrs}:${formattedMins}:${formattedSecs}`;
  }
}

export function selectAll(flag, arr, selected) {
  const arrUsers: any = new Set(arr.map((e) => e.id));
  const selecteds: any = new Set(selected);
  if (flag) return [...arrUsers.union(selecteds)];
  else return [...selecteds.difference(arrUsers)];
}

export async function getSvg(path) {
  const response = await fetch(path);
  const svg = await response.text();
  return svg;
}

export function getFileUrl(item: { image: File } | File | string): string {
  if (item === undefined) return "";
  if (typeof item === "string") return item;
  if ("image" in item) return URL.createObjectURL(item?.image);
  return URL.createObjectURL(item);
}
